import {IButton} from './../../../../../shared/card/card.component';
import {Component, Input, OnInit, OnDestroy, OnChanges} from '@angular/core';
import {SolutionService} from '../../../../Services/solution.service';
import {Solution} from '../../../../Models/Solution';
import {Subscription} from 'rxjs';
import {ActionType} from '../../../../Models/ActionType';
import {TranslateService} from '@ngx-translate/core';
import {SolutionStep} from '../../../../Models/SolutionStep';

@Component({
  selector: 'app-solution-step',
  templateUrl: './solution-step.component.html',
  styleUrls: ['./solution-step.component.scss']
})
export class SolutionStepComponent implements OnInit, OnDestroy, OnChanges {
  @Input() Index: number;
  public solution: Solution = new Solution();
  private subscriptions: Subscription[] = [];
  public actionTypes: ActionType[] = [];
  public actionType: ActionType = new ActionType();
  public nextSteps: { label: string, value: number }[] = [];
  public headerButtons = [];
  public specialButtons: IButton[] = [];

  constructor(
    public solutionService: SolutionService,
    public translate: TranslateService
  ) {
  }

  ngOnInit() {

    this.headerButtons.push({
      btnIcon: 'fa fa-trash-o fa-lg',
      method: 'removeSolution',
      customClass: 'action-button'
    });
    this.headerButtons.push({
      btnIcon: 'fa fa-plus fa-lg',
      method: 'appendStep',
      customClass: 'action-button'
    });

    this.headerButtons.forEach(items => {
      this.specialButtons.push({
        btnIcon: items.btnIcon,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass
      });
    });

    this.load();
  }

  load() {
    this.solutionService.getActionTypes().then((actionTypes) => {
      this.actionTypes = actionTypes;
      this.subscriptions.push(
        this.solutionService.solution.subscribe(solution => {
          this.solution = solution;
          if (this.solution.solutionSteps[this.Index] && this.solution.solutionSteps[this.Index].actionType) {
            this.actionType = this.actionTypes.find((actionType) => actionType.id === this.solution.solutionSteps[this.Index].actionType);
          }

          this.nextSteps = [];
          for (const key of Object.keys(solution.solutionSteps)) {
            if (+key > this.Index) {
              this.nextSteps.push({
                label: this.translate.instant('admin.solution.template.step') + ' ' + (+key + 1),
                value: +key
              });
            }
          }
          this.nextSteps.push({
            label: this.translate.instant('doctrine.solution.end_step'),
            value: -1
          });
        })
      );
    });
  }

  ngOnChanges() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
    this.load();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  actionTypeChange() {
    this.actionType = this.actionTypes.find((actionType) => actionType.id === this.solution.solutionSteps[this.Index].actionType);
    this.solutionService.solution.next(this.solution);
  }

  callFunction(method) {
    this[method]();
  }

  removeSolution() {
    this.solution.solutionSteps = this.solution.solutionSteps.filter((item, index) => {
      // handle next step
      item.nextStep = this.handleNextStep(item.nextStep);
      // handle confirmation next step
      if (item.actionConfirm) {
        item.actionConfirm.primaryStep = this.handleNextStep(item.actionConfirm.primaryStep);
        item.actionConfirm.secondaryStep = this.handleNextStep(item.actionConfirm.secondaryStep);
      }
      return index !== this.Index;
    });

    this.solutionService.solution.next(this.solution);
  }

  appendStep() {
    this.solution.solutionSteps.splice(this.Index + 1, 0, new SolutionStep());
    this.solution.solutionSteps.forEach((item, index) => {
      // handle next step
      item.nextStep = this.handleAppendNextStep(item.nextStep);
      // handle confirmation next step
      if (item.actionConfirm) {
        item.actionConfirm.primaryStep = this.handleAppendNextStep(item.actionConfirm.primaryStep);
        item.actionConfirm.secondaryStep = this.handleAppendNextStep(item.actionConfirm.secondaryStep);
      }
    });

    this.solutionService.solution.next(this.solution);
  }

  private handleNextStep(nextStep) {
    if (nextStep > this.Index) {
      return --nextStep;
    } else if (nextStep === this.Index) {
      return null;
    }
    return nextStep;
  }

  private handleAppendNextStep(nextStep) {
    if (nextStep && nextStep > this.Index) {
      return ++nextStep;
    }
    return nextStep;
  }
}
